import React from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import {
  FileInput,
  MultiFileInput,
  CheckboxInput,
  SelectInput
} from 'components/Common/Inputs';

const UploadPdfFormW8Imy = ({
  handleSubmit,
  handleImyChange,
  addImyToExistingLayer,
  id,
  initialValues }) => (
    <form
      id={ id }
      onSubmit={ values => handleSubmit(values) }
      className="form-horizontal"
    >
      <div className="form-group">
        <div className="col-5 col-sm-12">
          <label htmlFor="addImyToLayer" className="form-label">Add IMY form to this tier?</label>
        </div>
        <div className="col-7 col-sm-12">
          <Field
            id="pdf-form-type"
            name="addImyToLayer"
            component={ CheckboxInput }
            iValue="true"
            item="Yes"
            onChange={ (event, newVal, prevVal) => {
              handleImyChange(newVal);
            } }
          />
        </div>
      </div>
      { addImyToExistingLayer && <div className="form-group">
        <div className="col-5 col-sm-12 w8-imy-form-select">
          <Field
            id="pdf-form-type"
            name="formType"
            component={ SelectInput }
            className="form-select"
            required
            hideHints
            validate={ value => !value || !value.trim() }
          >
            <option value="" disabled>Choose a form type</option>
            <option value="w8imy">W-8IMY Sep-2016</option>
            <option value="w8imy_2017">W-8IMY Jun-2017</option>
            <option value="w8imy_2021">W-8IMY Oct-2021</option>
          </Field>
        </div>
        <div className="col-7 col-sm-12">
          <Field
            id="pdf-form-file"
            name="formFile"
            component={ FileInput }
            accept="application/pdf"
            className="form-input"
            required
          /><br />
        </div>
      </div> }
      <div>
        <h6>
          Beneficiary Forms
        </h6>
        <div className="form-group mark">
          <div className="col-5 col-sm-12">
            <label htmlFor="pdf-form-file" className="">W-8BEN-E Apr-2016 Forms</label>
          </div>
          <div className="col-7 col-sm-12">
            <Field
              id="pdf-form-file-beneficiaries"
              name="beneficiaryFormsOfW8BeneType"
              component={ MultiFileInput }
              className="form-input"
              accept="application/pdf"
            />
          </div>
        </div>
        <div className="form-group mark">
          <div className="col-5 col-sm-12">
            <label htmlFor="pdf-form-file" className="">W-8BEN-E Jul-2017 Forms</label>
          </div>
          <div className="col-7 col-sm-12">
            <Field
              id="pdf-form-file-beneficiaries"
              name="beneficiaryFormsOfW8Bene2017Type"
              component={ MultiFileInput }
              className="form-input"
              accept="application/pdf"
            /><br />
          </div>
        </div>
        <div className="form-group">
          <div className="col-5 col-sm-12">
            <label htmlFor="pdf-form-file" className="">W-8BEN Feb-2014 Forms</label>
          </div>
          <div className="col-7 col-sm-12">
            <Field
              id="pdf-form-file-beneficiaries"
              name="beneficiaryFormsOfW8Ben2014Type"
              component={ MultiFileInput }
              className="form-input"
              accept="application/pdf"
            />
          </div>
        </div>
        <div className="form-group">
          <div className="col-5 col-sm-12">
            <label htmlFor="pdf-form-file" className="">W-8BEN Jul-2017 Forms</label>
          </div>
          <div className="col-7 col-sm-12">
            <Field
              id="pdf-form-file-beneficiaries"
              name="beneficiaryFormsOfW8BenType"
              component={ MultiFileInput }
              className="form-input"
              accept="application/pdf"
            /><br />
          </div>
        </div>
        <div className="form-group">
          <div className="col-5 col-sm-12">
            <label htmlFor="pdf-form-file" className="">W-9 Dec-2014 Forms</label>
          </div>
          <div className="col-7 col-sm-12">
            <Field
              id="pdf-form-file-beneficiaries"
              name="beneficiaryFormsOfW9Type"
              component={ MultiFileInput }
              className="form-input"
              accept="application/pdf"
            />
          </div>
        </div>
        <div className="form-group">
          <div className="col-5 col-sm-12">
            <label htmlFor="pdf-form-file" className="">W-9 Jul-2017 Forms</label>
          </div>
          <div className="col-7 col-sm-12">
            <Field
              id="pdf-form-file-beneficiaries"
              name="beneficiaryFormsOfW92017Type"
              component={ MultiFileInput }
              className="form-input"
              accept="application/pdf"
            />
          </div>
        </div>
        <div className="form-group">
          <div className="col-5 col-sm-12">
            <label htmlFor="pdf-form-file" className="">W-9 Oct-2018 Forms</label>
          </div>
          <div className="col-7 col-sm-12">
            <Field
              id="pdf-form-file-beneficiaries"
              name="beneficiaryFormsOfW92018Type"
              component={ MultiFileInput }
              className="form-input"
              accept="application/pdf"
            />
          </div>
        </div>
        <div className="form-group">
          <div className="col-5 col-sm-12">
            <label htmlFor="pdf-form-file" className="">W-8EXP Sep-2016 Forms</label>
          </div>
          <div className="col-7 col-sm-12">
            <Field
              id="pdf-form-file-beneficiaries"
              name="beneficiaryFormsOfW8Exp2016Type"
              component={ MultiFileInput }
              className="form-input"
              accept="application/pdf"
            />
          </div>
        </div>
        <div className="form-group">
          <div className="col-5 col-sm-12">
            <label htmlFor="pdf-form-file" className="">W-8EXP Jul-2017 Forms</label>
          </div>
          <div className="col-7 col-sm-12">
            <Field
              id="pdf-form-file-beneficiaries"
              name="beneficiaryFormsOfW8ExpType"
              component={ MultiFileInput }
              className="form-input"
              accept="application/pdf"
            />
          </div>
        </div>
        <div className="form-group">
          <div className="col-5 col-sm-12">
            <label htmlFor="pdf-form-file" className="">W-8EXP Oct-2023 Forms</label>
          </div>
          <div className="col-7 col-sm-12">
            <Field
              id="pdf-form-file-beneficiaries"
              name="beneficiaryFormsOfW8Exp2023Type"
              component={ MultiFileInput }
              className="form-input"
              accept="application/pdf"
            />
          </div>
        </div>
      </div>
      <button
        type="submit"
        id="dummy-add-form-btn"
        className="none"
      >Add</button>
    </form>
);

UploadPdfFormW8Imy.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleImyChange: PropTypes.func.isRequired,
  addImyToExistingLayer: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  initialValues: PropTypes.shape({
    addImyToLayer: PropTypes.string,
    isFFI: PropTypes.string
  }).isRequired
};

export default reduxForm({
  form: 'uploadPdf-form-w8imy',
  initialValues: {
    addImyToLayer: '',
    isFFI: 'false'
  }
})(UploadPdfFormW8Imy);
